/**
 * Created by vlad.p on 11/6/2017.
 */

import {Injectable} from "@angular/core";
import {CountryData} from "../objects/country/countryData";
import {Http} from "@angular/http";
@Injectable()
export class CountryService {

    private countryData: CountryData[] = [];

    constructor(private http: Http) {
    }

    public getCode(country: string): string[] {
        if(String.isNullOrEmpty(country))
            return [];

        let countryData: CountryData = this.countryData.find(x => x.name.toLowerCase() == country.toLowerCase());

        if(countryData != null)
            return countryData.currencies;

        return [];
    }

    load(): Promise<CountryData[]> {

        let url = 'configuration/country-data.json';

        return this.http.get(url).toPromise().then(x => {
            this.countryData = x.json();

            return this.countryData;
        });
    }

}


// WEBPACK FOOTER //
// ./app/services/CountryService.ts